import { useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

const InboxScreen = lazy(() => import('../screens/inbox/InboxScreen.js'));

/** Messagerie centrale (vague 5) : liste, et conversation ouverte si l'adresse la désigne. */
export default function InboxPage() {
  const { interventionId } = useParams({ strict: false }) as { interventionId?: string };
  return (
    <GarageGate>
      <InboxScreen interventionId={interventionId ?? null} />
    </GarageGate>
  );
}
